export default __webpack_public_path__ + "static/media/github.91e40f20.svg";